import {isAppraiser} from '../../../utils/app'
export default {
    isAppraiser         : isAppraiser || 0, //鉴定权限

    jdConfig            : {
        periods         : null, //年代 100 秦汉
        trend           : null, //价格趋势
        service         : null, //服务态度
        speed           : null, //鉴定速度
        isReal          : null, //鉴定结论
    }, //时代 价格趋势 服务 态度 鉴定速度配置

    categoryTabs        : null, //分类标签

    appraisers          : {
        myAppraiser     : null,
        appraisers      : null
    }, //鉴定选择鉴定师列表
    appraiserList       : null, //鉴定师列表
    orders              : null, //订单列表
    orderDetail         : null, //订单详情
    finishOrders        : null, //首页已鉴定完成的
    authenticatedList   : null, //鉴定师首页鉴定过的商品

    appraiserInfo       : {
        appraiser       : null,
        userTotal       : null,
        appraisersTotal : null
    }, //鉴定师统计信息

    detailAppraiser     : null,
    takeInfo            : {
        total           : 0,    //提现总数
        totalMoney      : 0,    //账户总金额
        money           : 0,    //可用金额
        list            : null  // 提现列表
    },
    searchKey           : '',
    moneyLog            : [] //鉴定师收入流水
}